var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ListCountComponent } from '../list/count.component';
import { ItemModalService } from './item-modal.service';
var ItemModalListCountComponent = /** @class */ (function (_super) {
    __extends(ItemModalListCountComponent, _super);
    function ItemModalListCountComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    ItemModalListCountComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.querySubscription = this.service.observable.subscribe(function (data) {
            _super.prototype.onSubscribe.call(_this, data.value);
        });
    };
    ItemModalListCountComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    ItemModalListCountComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.querySubscription.unsubscribe();
    };
    ItemModalListCountComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'item-modal-listcount',
                    template: "<p id=\"{{ componentName }}\">\n  <span class=\"sectionHeading sectionHeading-gray\">{{ (msg | async)['ListComponent.label.result1'] }}{{ pager.count }}{{ (msg | async)['ListComponent.label.result2'] }}</span><span\n    class=\"-note -ml-05 -autoBreak\">/ {{ (msg | async)['ListComponent.label.total1'] }}{{ (msg | async)['ListComponent.label.total2'] }}</span>\n</p>\n"
                }] }
    ];
    /** @nocollapse */
    ItemModalListCountComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ItemModalService }
    ]; };
    return ItemModalListCountComponent;
}(ListCountComponent));
export { ItemModalListCountComponent };
//# sourceMappingURL=item-modal-count.component.js.map